import { render } from "./OrderControls.vue?vue&type=template&id=3b442ff8&scoped=true"
import script from "./OrderControls.vue?vue&type=script&lang=js"
export * from "./OrderControls.vue?vue&type=script&lang=js"

import "./OrderControls.vue?vue&type=style&index=0&id=3b442ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b442ff8"]])

export default __exports__